<template>
  <div class="other-info-wrapper section">
    <div class="other-info-left">
      <div class="top">
        <span class="logo">
          <img class="index-logo" src="@/static/image/icon/index-logo.png" alt="logo" />
        </span>
        <span class="text">{{ $t('companyIntro.title') }}</span>
      </div>

      <div class="main-desc">
        {{ $t('companyIntro.desc1') }}
        <br /><br />
        {{ $t('companyIntro.desc2') }}
      </div>

      <div class="statics">
        <span
          v-for="(item, index) in staticsList"
          :key="item.labelKey"
          :class="['statics-item', { active: activeIndex === index }]"
          @mousemove="handleStaticsMouseMove(index)"
          @mouseout="handleStaticsMouseOut"
        >
          <div class="s-item">
            <div>
              <span class="num">{{ item.num }}</span>
              <span class="unit sub">+</span>
            </div>
            <div class="unit">{{ $t(item.labelKey) }}</div>
          </div>
        </span>
      </div>
    </div>

    <div class="other-info-right">
      <div class="inner">
        <img class="other-bg" src="@/static/image/bg_img/index-other-bg.png" alt="other-info-bg" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompanyIntro',
  data() {
    return {
      activeIndex: 0,
      count: 0,
      autoDelay: 2000,
      otherInfoTimer: null,
      otherInfoTimer2: null,
      staticsList: [
        { num: '60', labelKey: 'companyIntro.stats.ip' },
        { num: '50', labelKey: 'companyIntro.stats.branches' },
        { num: '800', labelKey: 'companyIntro.stats.clients' },
        { num: '40万', labelKey: 'companyIntro.stats.employees' }
      ]
    }
  },
  mounted() {
    this.startMainTimer()
  },
  beforeDestroy() {
    this.clearAllTimers()
  },
  methods: {
    runStep() {
      if (this.count > this.staticsList.length - 1) {
        this.count = 0
      }
      this.activeIndex = this.count
      this.count += 1
    },
    startMainTimer() {
      this.clearAllTimers()
      this.otherInfoTimer = setInterval(() => {
        this.runStep()
      }, this.autoDelay)
    },
    startResumeTimer() {
      this.clearAllTimers()
      this.otherInfoTimer2 = setInterval(() => {
        this.runStep()
      }, this.autoDelay)
    },
    clearAllTimers() {
      if (this.otherInfoTimer) {
        clearInterval(this.otherInfoTimer)
        this.otherInfoTimer = null
      }
      if (this.otherInfoTimer2) {
        clearInterval(this.otherInfoTimer2)
        this.otherInfoTimer2 = null
      }
    },
    handleStaticsMouseMove(index) {
      this.clearAllTimers()
      this.activeIndex = index
      this.count = index
    },
    handleStaticsMouseOut() {
      this.startResumeTimer()
    }
  }
}
</script>

<style scoped lang="scss">
.section {
  width: 1200px;
  margin: 0 auto;
}

.other-info-wrapper {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 58px;
  padding: 72px 0 188px;
}

.other-info-left {
  width: 620px;
  z-index: 2;
}

.other-info-right {
  width: 500px;
  z-index: 1;

  .inner {
    width: 100%;
    height: 720px;
    border: 1px solid #1c51a3;
    padding: 12px;
    box-sizing: border-box;
    background: #fff;
  }

  .other-bg {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
}

.top {
  display: flex;
  align-items: center;
}

.logo {
  display: inline-flex;
  align-items: center;
}

.index-logo {
  width: 36px;
  height: 36px;
  object-fit: contain;
}

.text {
  margin-left: 12px;
  color: #1c51a3;
  font-size: 20px;
  line-height: 1.25;
  font-weight: 400;
  letter-spacing: 0;
}

.main-desc {
  margin-top: 30px;
  color: #1f2d3d;
  text-align: left;
  font-size: 16px;
  line-height: 2.1;
}

.statics {
  position: absolute;
  left: 0;
  bottom: 250px;
  z-index: 5;
  width: 950px;
  min-height: 206px;
  background: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(2px);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: stretch;
}

.statics-item {
  flex: 1;
  min-width: 0;
  color: #1c51a3;
  cursor: pointer;
  display: table;
  transform: scale(1);
  transition: all 0.28s ease;
}

.statics-item .unit {
  font-size: 14px;
  color: inherit;
  font-weight: 700;
}

.statics-item .unit.sub {
  display: inline-block;
  vertical-align: top;
  font-size: 28px;
  margin-left: 2px;
}

.statics-item div {
  text-align: center;
}

.statics-item .s-item {
  display: table-cell;
  vertical-align: middle;
}

.statics-item .num {
  color: inherit;
  font-size: 68px;
  line-height: 1;
  font-weight: 700;
}

.statics-item .s-item > div:last-child {
  margin-top: 12px;
  font-size: 14px;
  font-weight: 600;
}

.statics-item.active {
  transform: scale(1.03);
  color: #ffffff;
  background-color: #1c51a3;
  position: relative;
  z-index: 2;
}

@media (max-width: 1366px) {
  .section {
    width: 92%;
    min-width: 1200px;
  }

  .text {
    font-size: 36px;
  }

  .main-desc {
    font-size: 15px;
    line-height: 2;
  }

  .other-info-wrapper {
    padding-bottom: 176px;
  }

  .other-info-right {
    width: 470px;

    .inner {
      height: 680px;
    }
  }

  .other-info-left {
    width: 610px;
  }

  .statics {
    width: 920px;
    bottom: 62px;
  }

  .statics-item .num {
    font-size: 62px;
  }
}
</style>
